import { render, staticRenderFns } from "./official.vue?vue&type=template&id=88268900&"
import script from "./official.vue?vue&type=script&lang=js&"
export * from "./official.vue?vue&type=script&lang=js&"
import style0 from "./official.vue?vue&type=style&index=0&id=88268900&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports